// Brand Assets
export const BRAND_LOGO = "https://customer-assets.emergentagent.com/job_bhopal-luxury-1/artifacts/ev6aogco_jalsa%20retreat%20%20logo%20%281%29.png";

// Video assets (using high-quality video URLs)
export const CINEMATIC_VIDEOS = {
  hero: {
    main: "https://player.vimeo.com/external/434045526.hd.mp4?s=c27eecc69a27dbc4ff2b87d38afc35f1a9e7c02e&profile_id=174",
    bar: "https://player.vimeo.com/external/511918647.hd.mp4?s=980b70fac3a50bb0e13e2d37c52a50e1d5597e64&profile_id=174",
    pool: "https://player.vimeo.com/external/370467553.hd.mp4?s=1b6c9e8ec0dfab65e6d69e1c9d2a6d2f8e6c9e8e&profile_id=174",
    dining: "https://player.vimeo.com/external/449982153.hd.mp4?s=5f36f32f6bf695d449555f54f7e05cc6da5e2bf0&profile_id=174"
  },
  properties: {
    jalsaRetreat: "https://player.vimeo.com/external/370467553.hd.mp4?s=1b6c9e8ec0dfab65e6d69e1c9d2a6d2f8e6c9e8e&profile_id=174",
    jalsaInn: "https://player.vimeo.com/external/434045526.hd.mp4?s=c27eecc69a27dbc4ff2b87d38afc35f1a9e7c02e&profile_id=174",
    hotelJalsa: "https://player.vimeo.com/external/449982153.hd.mp4?s=5f36f32f6bf695d449555f54f7e05cc6da5e2bf0&profile_id=174"
  }
};

// Property Images
export const PROPERTY_IMAGES = {
  jalsaRetreat: {
    hero: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/kkd2nxvn_SHS_2775-Pano.jpg",
    exterior: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/h8n5y3rh_SHS_2784-Pano.jpg",
    banquet: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/xr9udpsh_Jalsa%20Retreat%20Banquet%201.jpg",
    wedding: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/xp5qhdvu_Sarovar%20Garden%20-%20taapu%201%20.png",
    sarovarGarden: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/xp5qhdvu_Sarovar%20Garden%20-%20taapu%201%20.png",
    sarovarGarden2: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/wcfegcww_Sarovar%20Garden%20-%20taapu%202.jpg",
    gym: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/0emerrw5_Gym.jpg",
    reception: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/x70jjj8a_Reception%201.jpg",
    rooms: [
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/na83rgs7_SHS_2463.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/6xdanoha_SHS_2488.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/jdxxcg39_1.jpg"
    ],
    suiteRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/x94886ry_SHS_2457.jpg",
    deluxeRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/dmp27j3m_SHS_2488.jpg",
    executiveRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/toliglf7_SHS_2500.jpg",
    dining: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/sh4y1oex_PHOTO-2025-06-17-18-33-11%202.jpg",
    food: [
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/sh4y1oex_PHOTO-2025-06-17-18-33-11%202.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/koa3atof_PHOTO-2025-06-17-18-33-14%202.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/umyl2ipt_PHOTO-2025-06-17-18-33-14%203.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/dldc08bv_PHOTO-2025-06-17-18-33-14.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/7exzu423_PHOTO-2025-06-17-18-33-16.jpg"
    ]
  },
  jalsaInn: {
    hero: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/z3jbql7q_Jalsa%20Inn%20Facade.png",
    exterior: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/z3jbql7q_Jalsa%20Inn%20Facade.png",
    rooms: [
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/t18zxutw_deluxe%20room.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/lcdkaeuv_Luxury%20room%201.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/kuno9d2v_Luxury%20room.jpg"
    ],
    deluxeRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/t18zxutw_deluxe%20room.jpg",
    luxuryRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/lcdkaeuv_Luxury%20room%201.jpg",
    dining: "https://images.unsplash.com/photo-1616538994032-f7619b8bebb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxyZXN0YXVyYW50JTIwZGluaW5nfGVufDB8fHx8MTc3MDQ3MzkwMnww&ixlib=rb-4.1.0&q=85"
  },
  hotelJalsa: {
    hero: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/ymimjzmi_Jalsa%20MP%20Nagar%20Facade.png",
    exterior: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/ymimjzmi_Jalsa%20MP%20Nagar%20Facade.png",
    rooms: [
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/pxbyu9uz_classic%20room%20.png",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/btazfs9o_deluxe%20room.png",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/iapr40y0_Executive%20Room%201.png"
    ],
    classicRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/pxbyu9uz_classic%20room%20.png",
    deluxeRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/btazfs9o_deluxe%20room.png",
    executiveRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/iapr40y0_Executive%20Room%201.png",
    lobby: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/e9lgd1oz_reception.png",
    dining: "https://images.pexels.com/photos/13674457/pexels-photo-13674457.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  common: {
    lobby: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/e9lgd1oz_reception.png",
    dining: "https://images.pexels.com/photos/239975/pexels-photo-239975.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
};

// Bhopal Local Guide
export const BHOPAL_GUIDE = {
  title: "Discover Bhopal",
  description: "Experience the City of Lakes with our curated guide to Bhopal's finest attractions and UNESCO World Heritage Sites.",
  landmarks: [
    {
      name: "Upper Lake (Bada Talab)",
      distance: "15 min from Jalsa Retreat",
      description: "One of Asia's largest artificial lakes, perfect for boating and sunset views",
      image: "https://images.unsplash.com/photo-1745068249684-53f935f41f77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxCaG9wYWwlMjBsYWtlJTIwc3Vuc2V0JTIwSW5kaWF8ZW58MHx8fHwxNzcxMDgyMTA3fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      name: "Taj-ul-Masajid",
      distance: "20 min drive",
      description: "One of India's largest mosques, featuring stunning Indo-Islamic architecture",
      image: "https://images.unsplash.com/photo-1588324631685-79f9ab5941e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxUYWotdWwtTWFzYWppZCUyMEJob3BhbCUyMG1vc3F1ZXxlbnwwfHx8fDE3NzEwODIwOTN8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      name: "Van Vihar National Park",
      distance: "25 min drive",
      description: "Urban national park with tigers, lions, leopards and beautiful walking trails",
      image: "https://images.unsplash.com/photo-1643569072217-5d6552d31101?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxJbmRpYW4lMjB0aWdlciUyMHdpbGRsaWZlJTIwc2FmYXJpfGVufDB8fHx8MTc3MTA4MjEwNnww&ixlib=rb-4.1.0&q=85"
    },
    {
      name: "Sanchi Stupa (UNESCO)",
      distance: "45 min drive",
      description: "2300-year-old Buddhist monument, UNESCO World Heritage Site with iconic gateways",
      image: "https://images.unsplash.com/photo-1764809692564-9e134e370cbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxTYW5jaGklMjBTdHVwYSUyMEluZGlhJTIwQnVkZGhpc3QlMjBtb251bWVudHxlbnwwfHx8fDE3NzEwODIwOTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      name: "Bhimbetka Caves (UNESCO)",
      distance: "50 min drive",
      description: "30,000-year-old rock art shelters, UNESCO World Heritage Site with prehistoric paintings",
      image: "https://images.unsplash.com/photo-1751963928248-f12524eef370?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxCaGltYmV0a2ElMjByb2NrJTIwc2hlbHRlcnMlMjBVTkVTQ08lMjBJbmRpYXxlbnwwfHx8fDE3NzEwODIwOTd8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      name: "DB City Mall",
      distance: "10 min from Hotel Jalsa",
      description: "Premier shopping and entertainment destination in Bhopal",
      image: "https://images.unsplash.com/photo-1668802117202-a256a84d6daa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzaG9wcGluZyUyMG1hbGwlMjBpbnRlcmlvciUyMG1vZGVybiUyMGluZGlhfGVufDB8fHx8MTc3MDU1NTkwNHww&ixlib=rb-4.1.0&q=85"
    }
  ],
  activities: [
    "Sunset boat rides on Upper Lake",
    "Heritage walks in Old Bhopal",
    "Day trips to Sanchi & Bhimbetka UNESCO sites",
    "Food tours featuring authentic Bhopali cuisine",
    "Wildlife safari at Van Vihar National Park"
  ]
};

// Jalsa Legacy
export const JALSA_LEGACY = {
  founded: "2015",
  yearsOfExcellence: "10+",
  story: "Founded in 2015, Jalsa Group of Hotels has been Bhopal's premier hospitality destination for over a decade. What began as a vision to redefine hospitality in the City of Lakes has grown into three distinct properties, each offering its unique blend of elegance, comfort, and authentic Indian hospitality.",
  milestones: [
    {
      year: "2015",
      title: "The Beginning",
      description: "Started Hotel Sandalwood in Kolar, laying the foundation for our hospitality journey"
    },
    {
      year: "2016",
      title: "MP Nagar Expansion",
      description: "Started Hotel Jalsa in MP Nagar, establishing our presence in Bhopal's business district"
    },
    {
      year: "2022",
      title: "Brand Evolution",
      description: "Renamed Hotel Sandalwood to Jalsa Inn, unifying our brand identity across properties"
    },
    {
      year: "2023",
      title: "The Crown Jewel",
      description: "Started Jalsa Retreat in Neelbad with lakeside gardens and Bhopal's largest banquet facilities"
    },
    {
      year: "2026",
      title: "101 Bar & Lounge",
      description: "Started 101 Bar & Lounge at Jalsa Retreat, elevating Bhopal's nightlife and social scene"
    }
  ],
  vision: "To be Bhopal's most beloved hospitality brand, where every guest experience becomes a cherished memory.",
  values: [
    "Authentic Indian Hospitality",
    "Uncompromising Quality",
    "Sustainable Practices",
    "Community Engagement",
    "Innovation in Service"
  ]
};

// Room Categories for Jalsa Retreat
export const ROOM_CATEGORIES = {
  jalsaRetreat: [
    {
      name: "Deluxe Room",
      image: PROPERTY_IMAGES.jalsaRetreat.deluxeRoom,
      size: "320 sq ft",
      occupancy: "2 Adults",
      amenities: ["King Bed", "City View", "Free Wi-Fi", "Mini Bar", "Smart TV", "Glass Bathroom"],
      description: "The classic deluxe room comes with all the amenities and is equipped with a glass bathroom"
    },
    {
      name: "Executive Room",
      image: PROPERTY_IMAGES.jalsaRetreat.executiveRoom,
      size: "400 sq ft",
      occupancy: "2 Adults + 1 Child",
      amenities: ["King Bed", "City View", "Free Wi-Fi", "Mini Bar", "Smart TV", "Premium Amenities"],
      description: "Our elegantly furnished executive rooms are fully equipped with quality amenities and offer an unmatched experience of comfort"
    },
    {
      name: "Suite Room",
      image: PROPERTY_IMAGES.jalsaRetreat.suiteRoom,
      size: "550 sq ft",
      occupancy: "2 Adults + 2 Children",
      amenities: ["King Bed", "City View", "Private Balcony", "Living Area", "Jacuzzi", "Premium Bar"],
      description: "A lavish experience with spacious rooms, a private balcony overlooking the city & a jacuzzi to relax your mind, body & soul"
    }
  ],
  jalsaInn: [
    {
      name: "Deluxe Room",
      image: PROPERTY_IMAGES.jalsaInn.deluxeRoom,
      size: "280 sq ft",
      occupancy: "2 Adults",
      amenities: ["Queen Bed", "Free Wi-Fi", "Smart TV", "Work Desk", "AC"],
      description: "Comfortable and well-appointed room perfect for business and leisure travelers"
    },
    {
      name: "Luxury Room",
      image: PROPERTY_IMAGES.jalsaInn.luxuryRoom,
      size: "350 sq ft",
      occupancy: "2 Adults + 1 Child",
      amenities: ["King Bed", "Free Wi-Fi", "Smart TV", "Sofa Seating", "Glass Bathroom"],
      description: "Spacious room with premium amenities, sofa seating, and modern glass bathroom"
    }
  ],
  hotelJalsa: [
    {
      name: "Classic Room",
      image: PROPERTY_IMAGES.hotelJalsa.classicRoom,
      size: "260 sq ft",
      occupancy: "2 Adults",
      amenities: ["Queen Bed", "Free Wi-Fi", "LED TV", "Work Desk", "AC"],
      description: "Contemporary room in the heart of MP Nagar, ideal for city explorers"
    },
    {
      name: "Deluxe Room",
      image: PROPERTY_IMAGES.hotelJalsa.deluxeRoom,
      size: "320 sq ft",
      occupancy: "2 Adults",
      amenities: ["King Bed", "Free Wi-Fi", "LED TV", "Work Desk", "AC", "Premium Amenities"],
      description: "Spacious room with modern amenities and comfortable furnishings"
    },
    {
      name: "Executive Room",
      image: PROPERTY_IMAGES.hotelJalsa.executiveRoom,
      size: "380 sq ft",
      occupancy: "2 Adults + 1 Child",
      amenities: ["King Bed", "Free Wi-Fi", "LED TV", "Sitting Area", "Premium Amenities"],
      description: "Perfect for business travelers with additional space and comfort"
    }
  ]
};

// 101 Bar & Lounge Menu
export const BAR_MENU = {
  cocktails: [
    { name: "Jalsa Signature", price: "₹650", description: "Vodka, elderflower, fresh lime, prosecco" },
    { name: "Bhopal Breeze", price: "₹600", description: "Gin, cucumber, mint, tonic water" },
    { name: "Golden Sunset", price: "₹700", description: "Rum, mango, passion fruit, champagne" },
    { name: "Royal Reserve", price: "₹800", description: "Premium whiskey, bitters, orange, cherry" }
  ],
  spirits: [
    { name: "Premium Whiskey", price: "₹500-2000", brands: ["Glenfiddich", "Macallan", "Johnnie Walker Blue"] },
    { name: "Vodka Selection", price: "₹400-1500", brands: ["Grey Goose", "Belvedere", "Absolut"] },
    { name: "Gin Collection", price: "₹450-1800", brands: ["Bombay Sapphire", "Hendrick's", "Tanqueray"] },
    { name: "Rum Varieties", price: "₹400-1600", brands: ["Bacardi", "Captain Morgan", "Havana Club"] }
  ],
  appetizers: [
    { name: "Truffle Fries", price: "₹450", description: "Hand-cut fries with truffle oil and parmesan" },
    { name: "Mezze Platter", price: "₹750", description: "Hummus, falafel, pita, olives, feta" },
    { name: "Chicken Wings", price: "₹550", description: "BBQ or Buffalo style with blue cheese dip" },
    { name: "Artisan Cheese Board", price: "₹900", description: "Selection of premium cheeses with crackers and honey" }
  ]
};
